import { Box, Stack } from "@mui/material";
import { ActivityListGroup } from "web_myplann/Activities/Components/ActivityListGroup";
import { useActivitiesList } from "web_myplann/Activities/Hooks/useActivitiesList";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EmptyListSkeleton } from "web_myplann/Shared/Components/EmptyListSkeleton";
import { NativePullToRefresh } from "web_myplann/Shared/Components/NativePullToRefresh";
import { StyledCenteredStack } from "web_myplann/Shared/Components/StyledCenteredStack";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import { RowSkeletonLoader } from "web_myplann/Shared/RowSkeletonLoader";

export const ActivitiesListPage = () => {
	const { t } = useResource();

	const {
		solvedEvents,
		upcomingEvents,
		overdueEvents,
		resolvedEvents,
		isLoading,
		allSectionsEmpty,
		hasOtherSections,
	} = useActivitiesList();
	return (
		<MyPlannLayout
			topBar={<NavigationHeader title={t(Resources.Activity.List.title)} />}
		>
			{isLoading && (
				<StyledCenteredStack spacing={2} px={5} zIndex={10}>
					<RowSkeletonLoader />
					<RowSkeletonLoader />
					<RowSkeletonLoader />
				</StyledCenteredStack>
			)}

			<Box sx={{ opacity: isLoading ? 0 : 1, transition: "opacity 0.2s" }}>
				<NativePullToRefresh
					queryKeys={[
						TaskKeys.lists(),
						ActivityKeys.lists(),
						ActivityKeys.events(),
					]}
					spinnerOffset={-20}
				>
					{allSectionsEmpty && (
						<EmptyListSkeleton
							label={t(Resources.Activity.List.NoContent)}
							description={t(Resources.Activity.List.NoActivities)}
							data-testid="activities-list-page"
						/>
					)}

					{!allSectionsEmpty && (
						<Stack
							paddingTop={1.6}
							paddingBottom={2}
							gap={1.6}
							data-testid="activities-list-page"
						>
							<ActivityListGroup
								label={t(Resources.Common.solvedEvents)}
								emptyGroupText={
									hasOtherSections
										? t(Resources.Activity.List.NoTask)
										: undefined
								}
								{...solvedEvents}
							/>
							<ActivityListGroup
								label={t(Resources.Common.upcomingEvents)}
								{...upcomingEvents}
								emptyGroupText={t(Resources.Activity.List.NoUpcomingEvents)}
							/>
							<ActivityListGroup
								label={t(Resources.Common.overdueEvents)}
								{...overdueEvents}
								emptyGroupText={t(Resources.Activity.List.NoOverdueEvents)}
							/>
							<ActivityListGroup
								label={t(Resources.Common.resolvedEvents)}
								{...resolvedEvents}
								emptyGroupText={t(Resources.Activity.List.NoResolvedEvents)}
								noDivider
							/>
						</Stack>
					)}
				</NativePullToRefresh>
			</Box>
		</MyPlannLayout>
	);
};
